export default {
  appHeaderSize: '4.375rem',
  sidenavWidth: 300, // 18.75 rem
  sidenavWidthCollapsed: 64, // 3.75 rem
  docPreviewPanel: 360,
};
